import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { getters } from './profile/getters';
import { actions } from './profile/actions';
import { mutations } from './profile/mutations';
import { state } from '@/store/profile/state';

export function createStore() {
  const store: StoreOptions<RootState> = {
    state,
    getters,
    actions,
    mutations,
  };
  return new Vuex.Store<RootState>(store);
}
